import ToastNotificationDispatcher from "@Components/ToastNotification/actions";
import { Dispatch } from "@reduxjs/toolkit";

const copyToClipboard = (apiData: any, dispatch: Dispatch) => {
  if (apiData?.data) {
    navigator.clipboard.writeText(apiData.data).then(
      () => {
        const toastNotificationDispatcher = new ToastNotificationDispatcher(dispatch);
        toastNotificationDispatcher.openToast({
          title: "Link copied!",
        });
      },
      (err) => {
        console.error("Failed to copy:", err);
      },
    );
  }
};

export default copyToClipboard;
